/** Petpooja-style restaurant POS visual tokens */
export const petpooja = {
  bg: "#eef1f5",
  panel: "#ffffff",
  border: "#dde2e8",
  text: "#1a2332",
  textMuted: "#6b7785",
  header: "#1e2a3b",
  headerText: "#ffffff",
  accent: "#e85d04",
  accentDark: "#c94d00",
  accentLight: "#fff4ec",
  green: "#2ecc71",
  greenDark: "#27ae60",
  red: "#e74c3c",
  yellow: "#f39c12",
  blue: "#3498db",
  grey: "#95a5a6",
  tableVacant: "#27ae60",
  tableOccupied: "#e74c3c",
  tableReserved: "#f39c12",
  tableBlocked: "#95a5a6",
  tableSelected: "#e85d04",
  categoryColors: [
    "#fff4ec",
    "#e8f4fd",
    "#fce8e8",
    "#e8f8f0",
    "#f3e8ff",
    "#fff0e8",
    "#e8f0ff",
  ],
};

export const categoryBg = (index: number) =>
  petpooja.categoryColors[index % petpooja.categoryColors.length];

export const tableStatusColor = (status: string) => {
  switch (status) {
    case "occupied":
      return petpooja.tableOccupied;
    case "reserved":
      return petpooja.tableReserved;
    case "blocked":
      return petpooja.tableBlocked;
    case "vacant":
    default:
      return petpooja.tableVacant;
  }
};
